import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import {
  FilterEkycRequest,
  ImportEkycRequest,
  SendEmailEkycResultRequest,
  FilterHealthCheckRequest,
  ConfirmBatchHealthCheckRequest,
  SendEmailBatchHealthCheckRequest,
  GetPersonalHealthCheckDetailsRequest,
  ConfirmHealthCheckRequest,
  SendEmailHealthCheckRequest,
} from "../utils/types";
import {
  apiFilterEkyc,
  apiDownloadEkyc,
  apiImportEkyc,
  apiSendEmailEkycResult,
  apiFilterHealthCheck,
  apiGetFilterOptions,
  apiConfirmBatchHealthCheck,
  apiSendEmailBatchHealthCheck,
  apiGetPersonalHealthCheckDetails,
  apiConfirmHealthCheck,
  apiGetDetails,
  apiExportPdfDetails,
  apiSendEmailHealthCheck,
  apiGetFilterEkycOptions
} from "./services";
import { ACTION_TYPES } from "./actionTypes";
import {
  setFilterEkycState,
  setEkycList,
  setImportEkycState,
  setSendEmailEkycResultState,
  setFilterHealthCheckState,
  setFilterOptions,
  setHealthCheckList,
  setConfirmBatchHealthCheckState,
  setSendEmailBatchHealthCheckState,
  setConfirmHealthCheckState,
  setPersonalHealthCheckDetails,
  setDetails,
  setSendEmailHealthCheckState,
  setFilterEkycOptions
} from "./actions";
import { message } from 'antd';
import moment from 'moment';

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.FILTER_EKYC: {
        return await handleFilterEkyc(dispatch, action, getState);
      }
      case ACTION_TYPES.DOWNLOAD_EKYC_LIST: {
        return await handleDownloadEkycList(dispatch, action, getState);
      }
      case ACTION_TYPES.IMPORT_EKYC: {
        return await handleImportEkyc(dispatch, action, getState);
      }
      case ACTION_TYPES.SEND_EMAIL_EKYC_RESULT: {
        return await handleSendEmailEkycResult(dispatch, action, getState);
      }
      case ACTION_TYPES.FILTER_HEALTH_CHECK: {
        return await handleFilterHealthCheck(dispatch, action, getState);
      }
      case ACTION_TYPES.GET_FILTER_OPTIONS: {
        return await handleGetFilterOptions(dispatch, action, getState);
      }
      case ACTION_TYPES.CONFIRM_BATCH_HEALTH_CHECK: {
        return await handleConfirmBatchHealthCheck(dispatch, action, getState);
      }
      case ACTION_TYPES.SEND_EMAIL_BATCH_HEALTH_CHECK: {
        return await handleSendEmailBatchHealthCheck(dispatch, action, getState);
      }
      case ACTION_TYPES.GET_PERSONAL_HEALTH_CHECK_DETAILS: {
        return await handleGetPersonalHealthCheckDetails(dispatch, action, getState);
      }
      case ACTION_TYPES.CONFIRM_HEALTH_CHECK: {
        return await handleConfirmHealthCheck(dispatch, action, getState);
      }
      case ACTION_TYPES.GET_DETAILS: {
        return await handleGetDetails(dispatch, action, getState);
      }
      case ACTION_TYPES.EXPORT_PDF_DETAILS: {
        return await handleExportPdfDetails(dispatch, action, getState);
      }
      case ACTION_TYPES.SEND_EMAIL_HEALTH_CHECK: {
        return await handleSendEmailHealthCheck(dispatch, action, getState);
      }
      case ACTION_TYPES.GET_FILTER_EKYC_OPTIONS: {
        return await handleGetFilterEkycOptions(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleFilterEkyc = async (
  dispatch: Dispatch,
  action: TActionRequest<FilterEkycRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setFilterEkycState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiFilterEkyc(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setEkycList(response));
      dispatch(setFilterEkycState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setFilterEkycState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleDownloadEkycList = async (
  dispatch: Dispatch,
  action: TActionRequest<FilterEkycRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setFilterEkycState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiDownloadEkyc("POST", action.params!, `EKYC_LIST_${moment().format("DD_MM_YYYY_H_m_s")}.xlsx`);
  } catch (err: any) {
    message.error(err.response?.data.status.message);
  }
};

const handleImportEkyc = async (
  dispatch: Dispatch,
  action: TActionRequest<ImportEkycRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setImportEkycState({ isFetching: true, isSuccess: false, isFail: false, data: null }));
    const response = await apiImportEkyc(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setImportEkycState({ isFetching: false, isSuccess: true, isFail: false, data: response.data }));
    }
  } catch (err: any) {
    dispatch(setImportEkycState({ isFetching: false, isSuccess: true, isFail: true, data: err?.response?.data?.data }));
  }
};

const handleSendEmailEkycResult = async (
  dispatch: Dispatch,
  action: TActionRequest<SendEmailEkycResultRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setSendEmailEkycResultState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiSendEmailEkycResult(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setSendEmailEkycResultState({ isFetching: false, isSuccess: true, data: response.data }));
      message.success(`Gửi thành công ${response.data} email`);
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message ? err.response?.data.status.message : 'Oops, xin lỗi vì hệ thống gián đoạn, vui lòng thử lại sau ít phút! Rất xin lỗi vì đã làm gián đoạn trải nghiệm của bạn!');
    dispatch(setSendEmailEkycResultState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleFilterHealthCheck = async (
  dispatch: Dispatch,
  action: TActionRequest<FilterHealthCheckRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setFilterHealthCheckState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiFilterHealthCheck(action.params!);
    response.data.content.sort(function(a: any, b: any){return b.updatedAt - a.updatedAt})
    if (response?.status?.code === "A200") {
      dispatch(setHealthCheckList(response));
      dispatch(setFilterHealthCheckState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setFilterHealthCheckState({ isFetching: false, isSuccess: false, data: err }));
  }
};


const handleGetFilterOptions = async (
  dispatch: Dispatch,
  action: TActionRequest<null>,
  getState: () => {  }
) => {

  try {
    const response = await apiGetFilterOptions(null);

    if (response?.status?.code === "A200") {
      dispatch(setFilterOptions(response));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
  }
};

const handleConfirmBatchHealthCheck = async (
  dispatch: Dispatch,
  action: TActionRequest<ConfirmBatchHealthCheckRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setConfirmBatchHealthCheckState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiConfirmBatchHealthCheck(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setConfirmBatchHealthCheckState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setConfirmBatchHealthCheckState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleSendEmailBatchHealthCheck = async (
  dispatch: Dispatch,
  action: TActionRequest<SendEmailBatchHealthCheckRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setSendEmailBatchHealthCheckState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiSendEmailBatchHealthCheck(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setSendEmailBatchHealthCheckState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setSendEmailBatchHealthCheckState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleGetPersonalHealthCheckDetails = async (
  dispatch: Dispatch,
  action: TActionRequest<GetPersonalHealthCheckDetailsRequest>,
  getState: () => {  }
) => {

  try {
    const response = await apiGetPersonalHealthCheckDetails(action.params!);

    if (response) {
      dispatch(setPersonalHealthCheckDetails(response));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
  }
};

const handleConfirmHealthCheck = async (
  dispatch: Dispatch,
  action: TActionRequest<ConfirmHealthCheckRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setConfirmHealthCheckState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiConfirmHealthCheck(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setConfirmHealthCheckState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setConfirmHealthCheckState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleGetDetails = async (
  dispatch: Dispatch,
  action: TActionRequest<GetPersonalHealthCheckDetailsRequest>,
  getState: () => {  }
) => {

  try {
    const response = await apiGetDetails(action.params!);

    if (response) {
      dispatch(setDetails(response));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
  }
};

const handleExportPdfDetails = async (
  dispatch: Dispatch,
  action: TActionRequest<GetPersonalHealthCheckDetailsRequest>,
  getState: () => {  }
) => {

  try {
    const response = await apiExportPdfDetails(action.params!);

    if (response) {
      const url = window.URL.createObjectURL(response)
      const a = document.createElement('a')
      a.href = url
      a.download = `EKYC_RESULT_${action.params}_${moment().format("DD_MM_YYYY_H_m_s")}.pdf`
      a.click()
      a.remove()
      setTimeout(() => window.URL.revokeObjectURL(url), 500)
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
  }
};

const handleSendEmailHealthCheck = async (
  dispatch: Dispatch,
  action: TActionRequest<SendEmailHealthCheckRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setSendEmailHealthCheckState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiSendEmailHealthCheck(action.params!);
    if (response?.status?.code === "A200") {
      message.success('Gửi thành công email');
      dispatch(setSendEmailHealthCheckState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setSendEmailHealthCheckState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleGetFilterEkycOptions = async (
  dispatch: Dispatch,
  action: TActionRequest<null>,
  getState: () => {  }
) => {

  try {
    const response = await apiGetFilterEkycOptions(null);

    if (response?.status?.code === "A200") {
      dispatch(setFilterEkycOptions(response));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
  }
};
